import React, {useEffect, useState} from 'react';
import OtpSentIcon from '../Assets/SVG/otpSentIcon';
import Footer from '../Assets/footer';
import TextInput from '../../../Shared/TextInput/TextInput';
import Popup from '../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import Config from '../../../../Config';
import SendAgain from '../Assets/SVG/sendAgain';
import LightBulbIcon from '../Assets/SVG/lightBulb';
import HandWaveIcon from '../Assets/SVG/handWaveIcon';
import ArrowSignErrorIcon from '../Assets/SVG/arrowSignErrorIcon';

import CheckBox from '../../../Shared/CheckBox/Checkbox';
import {isMobile} from 'react-device-detect';
import {setOtpError, setRestrictedCodeError} from 'app/utilities/authentication/authenticationSlice';
import {connect} from 'react-redux';

const MailOTPInsert = (props) => {
  const [otpCode, setCode] = useState('');
  const [numOfAttempts, setNumOfAttempts] = useState(0);
  const [checkBoxChecked, setCheckBoxIsChecked] = useState(false);
  const [isErrorCheck, setErrorCheck] = useState(false);
  const [showChangePopup, setShowChangePopup] = useState(false);
  const [showExpiryPopup, setShowExpiryPopup] = useState(false);
  const [showMaxPopup, setShowMaxPopup] = useState(false);
  const [valiCode, setValiCode] = useState('');

  useEffect(() => {
    setErrorCheck(false);
    setNumOfAttempts(0);
    props.setOtpError(null);
    props.setRestrictedCodeError(null);

    return () => {
      if (props.authentication.formError.otpCodeError) {
        props.setOtpError(null);
      }
      if (props.authentication.formError.restrictedCodeError) {
        props.setRestrictedCodeError(null);
      }
    };
  }, []);

  const validateCode = async (code = null) => {
    let otpCodeSubmit = code ? code : otpCode;
    console.log('entered validateCode', {otpCode, valiCode});
    let checkedCodeContinue = true;
    if (props.showTerms && !checkBoxChecked) {
      setErrorCheck(true);
      return;
    }
    setErrorCheck(false);
    if (otpCodeSubmit == '' || otpCodeSubmit == null) {
      console.log('otp code is empty');
      props.setOtpError('יש להזין קוד אימות');
      checkedCodeContinue = false;
    }
    if ((valiCode == '' || valiCode == null) && props.displayCode) {
      console.log('valicode is empty');
      props.setRestrictedCodeError('יש להזין קוד זיהוי');
      checkedCodeContinue = false;
    }

    if (numOfAttempts > Config.verifyCodeAttemptsLimit) {
      props.setOtpError('לא ניתן לבצע ניסיונות נוספים');

      return;
    }
    if (!checkedCodeContinue) {
      console.log('checkedCodeContinue', checkedCodeContinue);
      return;
    }
    checkedCodeContinue = await props.onclick(otpCodeSubmit, valiCode);
    console.log('check', checkedCodeContinue);
    if (!checkedCodeContinue.isSuccess) {
      if (checkedCodeContinue.codeError == 1005) {
        setNumOfAttempts(numOfAttempts + 1);
      }
      if (checkedCodeContinue.codeError == 74) {
        setShowChangePopup(true);
      }
      if (checkedCodeContinue.codeError == 1003) {
        setShowExpiryPopup(true);
      }
      if (checkedCodeContinue.codeError == 1002) {
        setShowMaxPopup(true);
      }
    } else {
      props.setOtpError(null);
    }
  };
  const resendOtp = async (val) => {
    const res = await props.sendAgain(val);
  };
  const labelForCheck = (
    <span className='labelForCheck'>
      אישרתי את{' '}
      <a href={props.termsLink} target='_blank' rel='noopener noreferrer'>
        תקנון האתר
      </a>
    </span>
  );
  const phoneUsedDisplay = props.phoneUsed?.substring(0, 3) + '-' + props.phoneUsed?.substring(3, 10);

  const headerSend = props.typePhone ? (
    isMobile ? (
      <>
        <h3 className='heading withSecondary'>
          שלחנו קוד חד פעמי
          <br />
          ל-
          <span>
            {props.contactVal.substring(7, 10)}*****-*{props.contactVal.substring(0, 2)}
          </span>
          <br />
          שרשום אצלנו כמנהל החשבון
        </h3>
        <h3 className='secondaryHeading'>
          שימו לב, במידה והמספר המעודכן אינו המספר
          <br />
          של מנהל החשבון, יש לפנות לשירות הלקוחות
          <br />
          ב-{window.Config.technicalSupportPhone} לעדכון פרטים
        </h3>
      </>
    ) : (
      <h3 className='heading withSecondary'>
        שלחנו קוד חד פעמי ל-
        <span>
          {props.contactVal.substring(7, 10)}*****-*{props.contactVal.substring(0, 2)}
        </span>
        <br />
        שרשום אצלנו כמנהל החשבון
      </h3>
    )
  ) : (
    <h3 className='heading withSecondary mailAddress'>
      לא זיהינו את המספר
      <br />
      שלחנו לך קוד חד פעמי למייל
      <br />
      {props.contactVal}
    </h3>
  );

  return (
    <div className='screenContainer'>
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          await validateCode();
        }}>
        <OtpSentIcon />
        <h3 className='connectNotation'>התחברות</h3>
        {headerSend}
        <h3 className='secondaryHeading'>איזה קוד קיבלת?</h3>
        <TextInput
          autoFocus
          placeholder={'קוד אימות'}
          autoComplete='one-time-code'
          name='otp-code'
          value={otpCode}
          type='text'
          inputMode='numeric'
          maxLength={'6'}
          error={props.authentication.formError.otpCodeError}
          onChange={async (e) => {
            let isAutoCompleted = false;
            if (
              otpCode?.length == 0 &&
              e.target.value.length == 6 &&
              isMobile &&
              (!props.showTerms || (props.showTerms && checkBoxChecked)) &&
              (!props.displayCode || (props.displayCode && valiCode?.length > 0))
            ) {
              isAutoCompleted = true;
            }
            const numberRegex = /^\d+$/;
            if ((numberRegex.test(e.target.value) || e.target.value === '') && e.target?.value?.length <= 6) {
              setCode(e.target.value);
              props.setOtpError('');
              if (
                isAutoCompleted &&
                (!props.displayCode || (props.displayCode && valiCode?.length > 0)) &&
                (!props.showTerms || (props.showTerms && checkBoxChecked))
              ) {
                await validateCode(e.target.value.substring(0, 6));
              }
            }
          }}
        />
        <div className='resendButtons'>
          <div
            className='resendButton'
            onClick={async () => {
              await resendOtp(true);
            }}>
            <div>
              <SendAgain />
            </div>
            <div className='text'>
              לא קיבלתי קוד,
              <br />
              תשלחו שוב
            </div>
          </div>
          <div className='separator'></div>
          <div
            className='resendButton'
            onClick={() => {
              window.location.href = 'tel:*'+ window.Config.technicalSupportPhone;
            }}>
            <div className='text'>
              תעבירו אותי
              <br />
              לנציג ב{window.Config.technicalSupportPhone}
            </div>
          </div>
        </div>
        {props.displayCode && (
          <div className='valiCode'>
            <TextInput
              placeholder={'קוד זיהוי'}
              value={valiCode}
              error={props.authentication.formError.restrictedCodeError}
              onChange={(e) => {
                setValiCode(e.target.value);
                props.setRestrictedCodeError(null);
              }}
            />
          </div>
        )}

        {props.showTerms && (
          <div className='checkZone'>
            <CheckBox
              id='readTermsCheckbox'
              onCheck={() => setCheckBoxIsChecked(true)}
              onUncheck={() => setCheckBoxIsChecked(false)}
              checked={checkBoxChecked}
              error={isErrorCheck ? 'יש לאשר את תקנון האתר' : ''}
              label={labelForCheck}
            />
          </div>
        )}

        <Footer onclick={() => {}} stage={props.stage} />

        <Popup
          className='phone-update-popup'
          showPopUp={showChangePopup}
          onClose={async () => {
            setShowChangePopup(false);
            await props.contactAction(otpCode, valiCode, false);
          }}>
          <>
            <LightBulbIcon />
            <h3 className='heading'>
              האם לעדכן את {phoneUsedDisplay}
              <br />
              כמספר הטלפון הראשי
              <br />
              לזיהוי ויצירת קשר?
            </h3>
            <div className='phone-update-popup-actions'>
              <BtnSubmit
                type='button'
                text={'כן, תעדכנו לי'}
                className='continueButton'
                onclick={() => {
                  props.contactAction(otpCode, valiCode, true);
                  setShowChangePopup(false);
                }}
              />
              <button
                type='button'
                className='phone-update-popup-decline'
                onClick={async () => {
                  setShowChangePopup(false);
                  await props.contactAction(otpCode, valiCode, false);
                }}>
                אין צורך, תודה
              </button>
            </div>
          </>
        </Popup>

        <Popup
          showPopUp={showExpiryPopup}
          onClose={async () => {
            setShowExpiryPopup(false);
            props.resetProcess();
          }}>
          <>
            <HandWaveIcon />
            <h3 className='heading withSecondary'>
              שמחים שחזרתם!
              <br />
              אבל הקוד שקיבלתם
              <br />
              כבר לא בתוקף
            </h3>
            <h3 className='secondaryHeading'>
              כדי לשמור על הפרטים שלכם,
              <br />
              נתחיל את התהליך מחדש
            </h3>
            <BtnSubmit
              type='button'
              text={'אוקיי'}
              className='continueButton w-m-196'
              onclick={() => {
                setShowExpiryPopup(false);
                props.resetProcess();
              }}
            />
          </>
        </Popup>

        <Popup
          showPopUp={showMaxPopup}
          onClose={async () => {
            setShowMaxPopup(false);
            props.resetProcess();
          }}>
          <>
            <ArrowSignErrorIcon noTop={true} />
            <h3 className='heading withSecondary'>לקחתם את זה לקצה!</h3>
            <h3 className='secondaryHeading'>
              הגעתם למקסימום הנסיונות להזין את הקוד
              <br />
              שקיבלתם. כדי לשמור על הפרטים שלכם,
              <br />
              נתחיל את התהליך מחדש
            </h3>
            <BtnSubmit
              type='button'
              text={'אוקיי'}
              className='continueButton'
              onclick={() => {
                setShowMaxPopup(false);
                props.resetProcess();
              }}
            />
          </>
        </Popup>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    authentication: state.authentication,
    loginStage: state.authentication.loginStep,
  };
};

const mapDispatchToProps = {
  setOtpError,
  setRestrictedCodeError,
};

export default connect(mapStateToProps, mapDispatchToProps)(MailOTPInsert);
